import React, { useContext } from 'react';
import Button from 'react-bootstrap/Button';

import { NCRContext } from 'views';
import { UserContext } from 'components/routing';
import { useLocation } from 'react-router-dom';

const CreateReturn = () => {
  const { state } = useContext(NCRContext);
  const { user } = useContext(UserContext);

  const location = useLocation();

  const href = location.pathname.includes('/return')
    ? `/api/return/${state.ncr.id}/return`
    : `/api/ncr/${state.ncr.id}/return`;

  const visible =
    ['QA', 'GM'].includes(user.role) &&
    state.ncr.status.id === 8 &&
    // Do NOT show if NODE_ENV is "development"
    process.env.NODE_ENV !== 'development';

  const isDisabled = !!state.ncr.return_rta_number;

  return (
    visible && (
      <Button
        className="import-netsuite"
        variant="success"
        href={href}
        disabled={isDisabled}
      >
        Create Return Order
      </Button>
    )
  );
};

export { CreateReturn };
